/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect} from 'react';
import {autoUpdate, flip, offset, shift, useFloating} from "@floating-ui/react-dom";

function FloatingElement({
                             targetRef,
                             children,
                             width,
                             height,
                             placement,
                             animationFrame,
                             offsetMainAxis = 6,
                             className = ""
                         }) {
    const {x, y, reference, floating, strategy, refs, update} = useFloating({
        placement: placement ?? 'bottom-start',
        middleware: [offset({mainAxis: offsetMainAxis}), flip(), shift()],

    });

    useEffect(() => {
        if (targetRef?.current !== null) {
            reference(targetRef?.current);
        }
    }, [reference, targetRef?.current]);

    useEffect(() => {
        if (!refs.reference.current || !refs.floating.current) {
            return;
        }

        // Only call this when the floating element is rendered
        return autoUpdate(
            refs.reference.current,
            refs.floating.current,
            update, {animationFrame: animationFrame ?? false,}
        );
    }, [refs?.reference?.current, refs?.floating?.current, update]);

    return (
        <>
            <div
                ref={floating}
                className={className}
                style={{
                    position: strategy,
                    top: y ?? '1px',
                    left: x ?? '1px',
                    width: width,
                    height: height,
                }}
            >
                {children}
            </div>
        </>
    );
}

FloatingElement.propTypes = {};

export default FloatingElement;